<template>
    <div class="codics-admin-firm-book-body">
        <div class="codics-admin-firm-book-control">
            <el-input class="codics-admin-firm-book-control-input" placeholder="请输入搜索内容" v-model="searchTxt" clearable
                @input="searchChange">
                <el-button slot="append" icon="el-icon-search"
                    @click="nowSearchTxt = searchTxt; listPdfsFuc(true)"></el-button>
            </el-input>
            <el-popconfirm :title="'您确定要删除当前选中的' + selectData.length + '条数据吗？'" @confirm="deletePdfsFuc">
                <el-button class="codics-admin-firm-book-control-search" slot="reference" type="danger"
                    icon="el-icon-delete">批量删除</el-button>
            </el-popconfirm>
        </div>
        <!-- 添加音乐 -->
        <el-dialog title="添加音乐" :close-on-click-modal='false' :visible.sync="mp3State" width="80%">
            <el-form :model="addForm">
                <el-form-item label="播放状态" :label-width="formLabelWidth">
                    <el-select v-model="addForm.loop" placeholder="请选择音乐播放状态" value-key="value">
                        <el-option v-for="(item, index) in [{ value: 0, label: '循环播放' }, { value: 1, label: '播放完停止' }]"
                            :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="音乐状态" :label-width="formLabelWidth">
                    <el-select v-model="addForm.state" placeholder="请选择背景音乐状态" value-key="value">
                        <el-option v-for="(item, index) in [{ value: 0, label: '开启' }, { value: 1, label: '关闭' }]"
                            :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="mp3State = false">取 消</el-button>
                <el-button type="primary" @click="addMp3Fuc();">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改表单 -->
        <el-dialog title="修改PDF信息" :close-on-click-modal='false' :visible.sync="updatePdfState" width="70%"
            @close="closeDialog">
            <el-form :model="updateForm">
                <el-form-item label="PDF名称" :label-width="formLabelWidth">
                    <el-input v-model="updateForm.name" autocomplete="off" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="PDF详情" :label-width="formLabelWidth">
                    <el-input v-model="updateForm.detail" autocomplete="off" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="PDF状态" :label-width="formLabelWidth">
                    <el-select v-model="updateForm.state" placeholder="请选择商品状态" value-key="value">
                        <el-option
                            v-for="(item, index) in [{ value: 0, label: '上架' }, { value: 1, label: '下架' }, { value: 2, label: '冻结' }, { value: 3, label: '封禁' }]"
                            :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="画册封面（微信分享使用）" :label-width="formLabelWidth">
                    <el-upload class="codics-firm-pdf-himg-upload"
                        :style="{ '--himgSize': updateForm.himg == '' ? 'inline-block' : 'none' }"
                        action="cdn.bosscaigou.com" list-type="picture-card" :http-request="uploadFile" ref="imgUpload"
                        :on-remove="handleRemove">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addProductDialogVisibility = false;">取 消</el-button>
                <el-button type="primary" @click="updatePdfFuc();">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 书签管理弹窗 -->
        <el-dialog title="书签管理" custom-class="codics-pdf-tag-dialog" :close-on-click-modal='false' :visible.sync="tagState" width="60%">
            <div class="codics-admin-firm-book-tag-control">
                <el-button type="primary" icon="el-icon-plus" @click="tagFormState = true; tagFormType = 'add'; tagForm = { bid: tagBid, tag: '', pge: 1 }">新增书签</el-button>
            </div>
            <el-table stripe border class="codics-admin-firm-book-tag-table" :data="tagData" style="width: 100%">
                <el-table-column prop="id" label="ID" width="70">
                </el-table-column>
                <el-table-column prop="tag" label="标签文本">
                </el-table-column>
                <el-table-column prop="pge" label="页码" width="100">
                </el-table-column>
                <el-table-column align="right" label="操作" min-width="140">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="tagFormType = 'edit'; tagForm.id = scope.row.id; tagForm.bid = scope.row.bid; tagForm.tag = scope.row.tag; tagForm.pge = scope.row.pge; tagFormState = true">编辑</el-button>
                        <el-popconfirm title="确定删除该书签吗？" @confirm="delTagFuc(scope.row)">
                            <el-button size="mini" type="danger" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- 新增/修改书签弹窗 -->
        <el-dialog custom-class="codics-pdf-tag-dialog" :close-on-click-modal='false' :visible.sync="tagFormState" width="40%"
            :title="tagFormType == 'add' ? '新增书签' : '修改书签'">
            <el-form :model="tagForm" label-width="80px">
                <el-form-item label="标签文本">
                    <el-input v-model="tagForm.tag" placeholder="请输入书签标签文本" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="页码">
                    <el-input-number v-model="tagForm.pge" :min="1" controls-position="right" style="width: 200px;"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="tagFormState = false">取 消</el-button>
                <el-button type="primary" @click="saveTagFuc()">确 定</el-button>
            </div>
        </el-dialog>
        <el-table stripe class="codics-admin-firm-book-table" :data="searchTxt == '' ? pdfsData : searchData" border
            style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="40">
            </el-table-column>
            <!-- <el-table-column prop="id" label="ID" width="80">
            </el-table-column> -->
            <el-table-column prop="name" label="名称" width="100">
            </el-table-column>
            <el-table-column prop="detail" label="介绍" width="180">
            </el-table-column>
            <el-table-column prop="himg" label="封面" width="125">
                <template slot-scope="scope">
                    <el-image :src="'https://cdn.bosscaigou.com/' + scope.row.himg" fit="fill"
                        style="height: 100px;width: 100px;"></el-image>
                </template>
            </el-table-column>
            <el-table-column prop="url" label="二维码" width="125">
                <template slot-scope="scope">
                    <el-image :src="scope.row?.qrcode == null ? '' : scope.row?.qrcode" fit="fill"
                        style="height: 100px;width: 100px;"></el-image>
                </template>
            </el-table-column>
            <el-table-column prop="state" label="状态" width="70"
                :filters="[{ text: '上架', value: 0 }, { text: '下架', value: 1 }]" :filter-method="filterTag"
                filter-placement="bottom-end">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.state == 0 ? 'success' : 'warning'" disable-transitions>{{ scope.row.state
                        == 0 ? '上架' : '下架' }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="state" label="mp3" width="145">
                <template slot-scope="scope">
                    <el-button v-show="scope.row.mp3 != null" plain type="mini" style="margin-right: 10px;"
                        @click="playMp3(scope.row)">试听</el-button>
                    <el-upload v-show="scope.row.mp3 == null" action="cdn.bosscaigou.com" accept=".mp3"
                        :http-request="(params) => uploadFile2(params, scope.row.id)" multiple :limit="1"
                        :show-file-list="false">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <!-- <el-button v-show="scope.row.mp3 != null" style="margin-left: 10px;" plain type="mini">{{
                        scope.row.mp3?.state == 0 ? "关闭" :
                        "开启" }}</el-button> -->
                    <el-popconfirm v-show="scope.row.mp3 != null" title="这是一段内容确定删除吗？" @confirm="delMp3(scope.row)">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
            <el-table-column prop="url" label="PDF" width="102">
                <template slot-scope="scope">
                    <el-popover placement="right" width="180">
                        <el-input-number v-model="zipNum" controls-position="right" :min="1" :max="5"
                            style="margin-bottom: 10px;"></el-input-number>
                        <el-slider v-model="hmNum" :min="10" :max="100"></el-slider>
                        <el-upload action="cdn.bosscaigou.com" accept=".pdf"
                            :http-request="(params) => uploadFile3(params, scope.row.id)" :limit="1"
                            :show-file-list="false">
                            <el-button type="warning">点击上传</el-button>
                        </el-upload>
                        <el-button type="mini" slot="reference" @click="updateForm.id = scope.row.id">点击上传</el-button>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="createtime" label="创建时间" width="250">
            </el-table-column>
            <el-table-column align="right" label="操作" min-width="150">
                <template slot-scope="scope">
                    <el-button size="mini" type="success" @click="jumpToPdf(scope.$index, scope.row)">跳转</el-button>
                    <el-button size="mini" type="warning" @click="openTagDialog(scope.row)">书签</el-button>
                    <el-button size="mini"
                        @click="updatePdfState = true; updateForm.id = scope.row.id; updateForm.name = scope.row.name; updateForm.state = scope.row.state; handleEdit(scope.row)"
                        style="margin-right: 10px;">编辑</el-button>
                    <el-popconfirm title="这是一段内容确定删除吗？" @confirm="deletePdfsFuc([scope.row.id])">
                        <el-button v-show="scope.row.children == null" size="mini" type="danger"
                            slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="codics-admin-firm-book-table-page" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="searchTxt == '' ? dataSize : searchSize"
            layout="total, sizes, prev, pager, next, jumper" :total="searchTxt == '' ? maxSize : searchMax">
        </el-pagination>
        <MyLoading v-show="uploadState" :show-txt="'文件上传进度' + uploadProgress + '%，请耐心等待...'"></MyLoading>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import * as qiniu from 'qiniu-js';
import QRCode from 'qrcode';
import { listPdfs, deletePdfs, updatePdf, getQiNiuToken, addMp3, deleteMp3, updatePdf2, listPdfTags, addPdfTag, updatePdfTag, deletePdfTags } from '@/api';
import { randomString, base64ToFile } from '@/utils/myutils';
import MyLoading from '@/components/MyLoading';
export default {
    data() {
        return {
            hmNum: 92,
            visible: false,
            uploadState: false,
            uploadProgress: 0,
            formLabelWidth: '100px',
            updatePdfState: false,
            mp3State: false,
            searchTxt: '',
            nowSearchTxt: '',
            currentPage: 1,
            searchPage: 1,
            maxSize: 0,
            searchMax: 0,
            dataSize: 10,
            searchSize: 10,
            selectData: [],
            nowSearchTxt: '',
            pdfsData: [],
            searchData: [],
            zipNum: 2,
            updateForm: {
                id: null,
                name: '',
                detail: '',
                state: 0,
                himg: ''
            },
            addForm: {
                pid: null,
                url: '',
                loop: 0,
                state: 0
            },
            qiNiuInfo: {
                token: null
            },
            nowPages: 0,
            tagState: false,
            tagBid: null,
            tagData: [],
            tagFormState: false,
            tagFormType: 'add',
            tagForm: {
                id: null,
                bid: null,
                tag: '',
                pge: 1
            },

        }
    },
    mounted() {

        import('@/../public/js/pdf.mjs');
        import('@/../public/js/pdf.worker.mjs');
        import('@/../public/js/FileSaver.js');
        import('@/../public/js/jszip.min.js');

        this.listPdfsFuc();

        this.getTokenFuc();

    },
    methods: {
        async updatePdf2Fuc() {

            const t = this.imgList.join(",");

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await updatePdf2({ id: this.updateForm.id, url: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '数据修改成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        renderImg(_this, pdfFile, pageNumber, canvasContext, canvas) {

            // console.log(pdfFile)

            pdfFile.getPage(pageNumber).then(function (page) { //逐页解析PDF

                var newcanvas = canvasContext.canvas;

                var viewport = page.getViewport({ scale: _this.zipNum || 1 }); // 页面缩放比例
                //设置canvas真实宽高
                newcanvas.width = viewport.width;//page._pageInfo.view[2]

                newcanvas.height = viewport.height;//page._pageInfo.view[3]

                canvasContext.translate(newcanvas.width / 2, newcanvas.height / 2);

                canvasContext.translate(-newcanvas.width / 2, -newcanvas.height / 2);

                newcanvas.style.width = "100%";

                newcanvas.style.height = "100%";

                var renderContext = {
                    canvasContext: canvasContext,
                    viewport: viewport
                };

                page.render(renderContext).promise.then(function () {

                    canvasContext.translate(newcanvas.width / 2, newcanvas.height / 2);

                    canvasContext.translate(-newcanvas.width / 2, -newcanvas.height / 2);

                    const a = base64ToFile(canvas.toDataURL("image/webp", Number.parseFloat((_this.hmNum / 100).toFixed(1))), 'image.webp', 'image.webp');

                    let pdfPath = 'huayuan/img/' + randomString(10) + '_' + new Date().getTime() + '_' + _this.userInfo.user.id + '.webp';
                    // 上传文件
                    const observer = {
                        next(res) {

                            _this.uploadProgress = res.total.percent.toFixed(2 / _this.totalPages);

                        },
                        error(err) {
                            _this.uploadState = false;
                        },
                        complete(res) {

                            _this.imgList[pageNumber - 1] = res.key;

                            _this.nowPages++;

                            if (_this.nowPages === _this.totalPages) {

                                _this.bookVisible = true;

                                _this.uploadState = false;

                                _this.nowPages = 0;

                                _this.totalPages;

                                _this.updatePdf2Fuc();

                            }

                            // _that.addPdfFuc(, , '')
                        }
                    }
                    console.log(a);
                    const observable = qiniu.upload(a, pdfPath, _this.qiNiuInfo.token, {

                        params: { 'x:name': 'qiniu' },

                    }, {
                        region: qiniu.region.z0
                    })
                    const subscription = observable.subscribe(observer) // 上传开始

                });
            });
            return;
        },
        uploadFile3(uploadInfo) {

            this.totalPages = 0;

            this.nowPages = 0;

            const _this = this;

            _this.uploadState = true;

            _this.addForm.name = uploadInfo.file.name.split('.')[0];

            _this.imgList = [];

            var reader = new FileReader();

            reader.readAsDataURL(uploadInfo.file); //将文件读取为 DataURL

            reader.onload = function (e) { //文件读取成功完成时触发

                _this.loadProgress = 30;

                pdfjsLib.getDocument(reader.result).promise.then(function (pdf) {

                    if (pdf) {

                        _this.totalPages = pdf.numPages;

                        for (var i = 1; i <= _this.totalPages; i++) {

                            var canvas = document.createElement('canvas');

                            canvas.id = "pageNum" + i;

                            var context = canvas.getContext('2d');

                            _this.renderImg(_this, pdf, i, context, canvas);

                        }

                    }

                });

            };

        },
        async getTokenFuc() {
            let data = await getQiNiuToken();
            if (data.code == 200) {
                this.qiNiuInfo.token = data.uptoken;
            } else {
                this.$message.error(data.message);
            }
        },
        async creatQrCode(i, QRlink) {   // QRlink是二维码的内容
            let opts = {
                errorCorrectionLevel: "L",//容错级别
                type: "image/png",//生成的二维码类型
                quality: 0.3,//二维码质量
                margin: 1,//二维码留白边距
                width: 100,//宽
                height: 100,//高
                text: QRlink,//二维码内容
                color: {
                    dark: "#000",//前景色
                    light: "#fff"//背景色
                }
            };
            await QRCode.toDataURL(QRlink, opts, (err, url) => {
                if (err) throw err
                //将生成的二维码路径复制给data的QRImgUrl
                // console.log(url)
                i['qrcode'] = url;
            })
        },
        async getProductTypesData() {

            let data = await getProductTypeList();

            if (data.code == 200) {

                this.productTypeList = data.data;

            } else {

                this.$message.error(data.message);

            }

        },
        jumpToPdf(idx, row) {
            window.open('https://book.cnhonorgroup.com/book/show/' + row.id, '_blank');
        },
        async listPdfsFuc(s) {

            if (s) {

                if (this.searchTxt == '') {

                    this.$notify({
                        title: '警告',
                        message: '搜索内容不能为空！',
                        type: 'warning'
                    });

                    return;

                }

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await listPdfs({ key: this.nowSearchTxt, pge: this.nowSearchTxt == '' ? this.currentPage : this.searchPage, psz: this.nowSearchTxt == '' ? this.dataSize : this.searchSize });

            loading.close();

            if (data.code == 200) {

                if (this.nowSearchTxt == '') {

                    this.pdfsData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

                for (var i in (this.nowSearchTxt == '' ? this.pdfsData : this.searchData)) {
                    this.creatQrCode((this.nowSearchTxt == '' ? this.pdfsData : this.searchData)[i], 'https://book.cnhonorgroup.com/book/show/' + (this.nowSearchTxt == '' ? this.pdfsData : this.searchData)[i]?.id)//u=' + this.userInfo?.user.id + '&
                }

            } else {

                this.$message.error(data.message);

            }

        },
        handleSizeChange(val) {
            if (this.nowSearchTxt == '') {
                this.dataSize = val;
                this.listPdfsFuc();
            } else {
                this.searchSize = val;
                this.listPdfsFuc();
            }
        },
        handleCurrentChange(val) {
            if (this.nowSearchTxt == '') {
                this.currentPage = val;
                this.listPdfsFuc();
            } else {
                this.searchPage = val;
                this.listPdfsFuc();
            }
        },
        filterTag(v, r, c) {

            return r.state === v;

        },
        async delMp3(row) {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteMp3({ id: row.mp3.id });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }
        },
        handleSubCat(value) {
            // 获取value值
            this.addForm.p = value.length == 0 ? 0 : value[value.length - 1];
            // 获取label 值
            // console.log(this.$refs["refSubCat"].getCheckedNodes()[0].label)
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        async addProductTypeFuc() {

            if (this.addForm.l == '') {

                this.$notify({
                    title: '警告',
                    message: '分类名称不能为空！',
                    type: 'warning'
                });

                return true;

            }

            let data = await addProductType(this.addForm);

            if (data.code == 200) {

                this.$message({
                    message: '添加商品分类成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        async deletePdfsFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deletePdfs({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.data + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        async updatePdfFuc() {

            if (this.updateForm.id == null || this.updateForm.name == '' || this.updateForm.state == null) {

                this.$message({
                    showClose: true,
                    message: '要更新的数据信息不能为空！',
                    type: 'warning'
                });

                return true;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await updatePdf(this.updateForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '数据信息更新成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        uploadFile(uploadInfo) {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let imgPath = 'huayuan/img/' + randomString(10) + '_' + new Date().getTime() + '_' + this.userInfo?.user?.id + '.png';

            const _that = this;

            console.log(12312312312313)
            // 上传文件
            const observer2 = {
                next(res) {
                    console.log('next: ', res)
                },
                error(err) {
                    console.log(err)
                },
                complete(res) {
                    console.log('complete: ', res)
                    _that.updateForm.himg = res.key;

                }
            }
            // console.log(uploadInfo.file);
            const observable2 = qiniu.upload(uploadInfo.file, imgPath, _that.qiNiuInfo.token, {}, {
            })
            const subscription2 = observable2.subscribe(observer2) // 上传开始

            loading.close();
        },
        uploadFile2(uploadInfo, id) {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let imgPath = 'huayuan/mp3/' + randomString(10) + '_' + new Date().getTime() + '_' + this.userInfo?.user?.id + '.mp3';

            const _that = this;
            // 上传文件
            const observer2 = {
                next(res) {
                    // console.log('next: ', res)
                },
                error(err) {
                    // console.log(err)
                },
                complete(res) {
                    // console.log('complete: ', res)
                    _that.addForm.url = res.key;

                    _that.addForm.pid = id;

                    loading.close();

                    _that.mp3State = true;

                }
            }
            // console.log(uploadInfo.file);
            const observable2 = qiniu.upload(uploadInfo.file, imgPath, this.qiNiuInfo.token, {}, {
            })
            const subscription2 = observable2.subscribe(observer2) // 上传开始
            // console.log(subscription);
            // subscription2.unsubscribe() // 上传取消
        },
        async addMp3Fuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await addMp3(this.addForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '添加音乐成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

            this.mp3State = false;

        },
        playMp3(row) {


            // this.audio.loop = row?.mp3?.lop == 0; // 设置音乐循环播放
            if (this.audio == null) {
                this.audio = new Audio('https://cdn.bosscaigou.com/' + row?.mp3?.url);
                this.audio.play();
            } else {
                this.audio.pause();
                this.audio = null;
            }

        },
        handleEdit(row) {
            this.updateForm.id = row.id;
            this.updateForm.name = row.name;
            this.updateForm.detail = row.detail;
            this.updateForm.state = row.state;
            this.updateForm.himg = row.himg;
            setTimeout(() => {
                this.$refs['imgUpload'].uploadFiles.push({
                    name: '',
                    percentage: '',
                    raw: '',
                    size: '',
                    status: '',
                    uid: new Date().getTime(),
                    url: "https://cdn.bosscaigou.com/" + row.himg
                })
            }, 30);
        },
        handleRemove() {
            this.updateForm.himg = '';
        },
        closeDialog(done) {
            this.$refs['imgUpload'].uploadFiles = [];
        },
        // 打开书签管理弹窗
        openTagDialog(row) {
            this.tagState = true;
            this.tagBid = row.id;
            this.listTagsFuc();
        },
        // 查询当前画册的书签列表
        async listTagsFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await listPdfTags({ bid: this.tagBid });

            loading.close();

            if (data.code == 200) {

                this.tagData = data.data;

            } else {

                this.$message.error(data.message);

            }

        },
        // 新增/修改书签
        async saveTagFuc() {

            if (this.tagForm.tag == '' || this.tagForm.pge == null) {

                this.$message({
                    showClose: true,
                    message: '书签标签文本和页码不能为空！',
                    type: 'warning'
                });

                return true;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = this.tagFormType == 'add' ? await addPdfTag(this.tagForm) : await updatePdfTag(this.tagForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: this.tagFormType == 'add' ? '书签添加成功！' : '书签修改成功！',
                    type: 'success'
                });

                this.tagFormState = false;

                this.listTagsFuc();

            } else {

                this.$message.error(data.message);

            }

        },
        // 删除书签
        async delTagFuc(row) {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deletePdfTags({ ids: [row.id] });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '书签删除成功！',
                    type: 'success'
                });

                this.listTagsFuc();

            } else {

                this.$message.error(data.message);

            }

        }
    },
    computed: {
        ...mapState(['userInfo'])
    },
    components: {
        MyLoading
    }
}
</script>

<style>
/* 后台管理端主页 */
.codics-admin-firm-book-body {
    height: fit-content;
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
    box-sizing: border-box;
    padding: 20px;
}

/* 后台管理页面主页 */
.codics-admin-firm-book-control {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    /* margin-bottom: 15px; */
}

/* 后台管理页面主页控制栏 */
.codics-admin-firm-book-control-input {
    width: 200px !important;
    position: relative;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
}

/* 后台管理页面控制栏搜索按钮 */
.codics-admin-firm-book-control-search {
    position: relative;
    float: left;
    margin-left: 0px !important;
    margin-right: 20px !important;
}

/* 表格控件 */
.codics-admin-firm-book-table {
    height: fit-content;
    width: 100% !important;
    position: relative;
    float: left;
    margin-bottom: 20px;
}

/* 表格分页控件 */
.codics-admin-firm-book-table-page {
    position: relative;
    float: right;
    right: 0;
}

.codics-firm-pdf-himg-upload .el-upload {
    display: var(--himgSize);
}

/* 书签管理弹窗 */
.codics-admin-firm-book-tag-control {
    width: 100%;
    position: relative;
    overflow: hidden;
    margin-bottom: 15px;
}

.codics-admin-firm-book-tag-table {
    width: 100% !important;
    position: relative;
}

/* 书签弹窗 body 兜底：避免浮动/内联元素导致高度塌陷 */
.codics-pdf-tag-dialog .el-dialog__body {
    overflow: hidden;
}
</style>